// Определим типы для переводов
export type Translation = {
  name: string;
  role: string;
  development: {
    title: string;
    items: ReadonlyArray<{
      title: string;
      desc: string;
    }>;
  };
  techStack: {
    title: string;
  };
  contacts: {
    title: string;
    email: string;
    social: string;
  };
  about: {
    title: string;
    text: string;
  };
  mentoring: {
    title: string;
    intro: ReadonlyArray<string>;
    roadmap: {
      title: string;
      items: ReadonlyArray<string>;
    };
    technologies: {
      title: string;
      items: ReadonlyArray<string>;
    };
    conclusion: ReadonlyArray<string>;
  };
  footer: {
    rights: string;
  };
};

export type Translations = {
  readonly [key in 'en' | 'ru' | 'th']: Translation;
};

export const translations: Translations = {
  en: {
    name: "Sergey Bubnov",
    role: "Full Stack Developer | Mentor",
    development: {
      title: "Development Experience",
      items: [
        {
          title: "Web Development",
          desc: "Development and maintenance of web applications using JavaScript, ReactJS, and NodeJS"
        },
        {
          title: "Mobile Development",
          desc: "Design and implementation of mobile applications using React Native"
        },
        {
          title: "Backend Development",
          desc: "Implementation and configuration of server solutions using NodeJS and ExpressJS"
        },
        {
          title: "Databases",
          desc: "Working with ORM and databases, particularly PostgreSQL through TypeORM"
        },
        {
          title: "Architecture",
          desc: "Applying DDD development methodologies to improve project structure"
        },
        {
          title: "DevOps",
          desc: "Setting up and maintaining CI/CD infrastructure using Docker and GitLab"
        },
        {
          title: "Monitoring",
          desc: "Application performance monitoring and analysis using Kibana and Grafana"
        },
        {
          title: "UI/UX",
          desc: "Interface development using HTML, CSS and Figma"
        }
      ]
    },
    techStack: {
      title: "Technical Stack"
    },
    contacts: {
      title: "Contacts",
      email: "Email",
      social: "Social Networks"
    },
    about: {
      title: 'About Me',
      text: `<p>For me, programming is not just a way to make money, it's a way of life.</p>
             <p>With each project, I strive to deepen my knowledge and broaden my horizons, constantly following industry trends. I actively read professional literature and continuously develop.</p>
             <p>I believe in the power of teamwork and strive to be not only a performer but also a mentor for junior colleagues, actively supporting the exchange of knowledge and experience in the team.</p>
             <p>I have a personal project that has been successfully running for several years. I also teach programming to my students, trying to instill in them love and interest in this profession.</p>`
    },
    mentoring: {
      title: "Mentoring",
      intro: [
        "Once, my friend asked me to help him with learning, that's how I got my first student",
        "Along with the first student came the realization that the learning process brings great pleasure!",
        "It's very pleasant to see how a person gains new opportunities by acquiring new skills"
      ],
      roadmap: {
        title: "What we do:",
        items: [
          "Introduction to Linux operating system",
          "Developing your own website",
          "Learning JavaScript programming language",
          "Working with AI (artificial intelligence)",
          "Organizing and setting up workspace",
          "Understanding programs and operating system",
          "Publishing your project online"
        ]
      },
      technologies: {
        title: "Technologies we use:",
        items: [
          "Git (version control system)",
          "JavaScript (programming language)",
          "PostgresSQL (database)",
          "CSS (used for styling web pages)",
          "HTML (foundation of any web page)",
          "Docker (containerization tool)",
          "Nginx (popular web server)"
        ]
      },
      conclusion: [
        "Upon completion of training, students gain a comprehensive understanding of web development",
        "Fear disappears and understanding comes that any task can be solved",
        "If they set a goal to find a job, it won't be a problem",
        "The main thing is not to stand still and continue learning, then everything will work out!"
      ]
    },
    footer: {
      rights: "All rights reserved"
    }
  },
  ru: {
    name: "Сергей Бубнов",
    role: "Full Stack Разработчик | Ментор",
    development: {
      title: "Опыт Разработки",
      items: [
        {
          title: "Веб-разработка",
          desc: "Разработка и поддержка веб-приложений, используя JavaScript, ReactJS, и NodeJS"
        },
        {
          title: "Мобильная разработка",
          desc: "Проектирование и реализация мобильных приложений на платформе React Native"
        },
        {
          title: "Серверная разработка",
          desc: "Внедрение и настройка серверных решений с использованием NodeJS и ExpressJS"
        },
        {
          title: "Базы данных",
          desc: "Работа с ORM и базами данных, в частности с PostgreSQL через TypeORM"
        },
        {
          title: "Архитектура",
          desc: "Применение методологий разработки DDD для улучшения структуры проектов"
        },
        {
          title: "DevOps",
          desc: "Настройка и поддержка инфраструктуры CI/CD с использованием Docker и GitLab"
        },
        {
          title: "Мониторинг",
          desc: "Мониторинг и анализ производительности приложений с помощью Kibana и Grafana"
        },
        {
          title: "UI/UX",
          desc: "Разработка интерфейсов с использованием HTML, CSS и Figma"
        }
      ]
    },
    techStack: {
      title: "Технический стек"
    },
    contacts: {
      title: "Контакты",
      email: "Электронная почта",
      social: "Социальные сети"
    },
    about: {
      title: 'О себе',
      text: `<p>Для меня программирование — не просто способ заработка, это образ жизни.</p>
             <p>С каждым проектом я стремлюсь углублять свои знания и расширять кругозор, постоянно следуя за трендами отрасли. Я активно читаю профессиональную литературу и постоянно развиваюсь.</p>
             <p>Я верю в силу командной работы и стремлюсь быть не только исполнителем, но и наставником для младших коллег, активно поддерживая обмен знаниями и опытом в коллективе.</p>
             <p>У меня есть личный проект, успешно работающий уже несколько лет. Также я обучаю программированию своих учеников, стараясь привить им любовь и интерес к этой профессии.</p>`
    },
    mentoring: {
      title: "Менторство",
      intro: [
        "Однажды, мой знакомый попросил меня помочь ему с обучением, таким образом появился первый ученик",
        "Вместе с первым учеником, пришло осознание того, что процесс обучения приносит огромное удовольствие!",
        "Очень приятно видеть как человек получая новые навыки, обретает новые возможности"
      ],
      roadmap: {
        title: "Чем занимаемся:",
        items: [
          "Знакомство с операционной системой Linux",
          "Разработка собственного сайта",
          "Знакомство с языком программирования JavaScript",
          "Работа с AI (искусственный интеллект)",
          "Организация и настройка рабочего пространства",
          "Обсуждение работы программ и операционной системы",
          "Публикация Вашего проекта в сеть"
        ]
      },
      technologies: {
        title: "Список используемых технологий:",
        items: [
          "Git (система контроля версий)",
          "JavaScript (язык программирования)",
          "PostgresSQL (база данных)",
          "CSS (используется для стилизации веб-страниц)",
          "HTML (это основа любой веб-страницы, её каркас)",
          "Docker (это инструмент для контейнеризации приложений)",
          "Nginx (популярный веб-сервер)"
        ]
      },
      conclusion: [
        "По завершению обучения, у учеников складывается представление о web-разработке",
        "Уходит страх и приходит понимание, что любую задачу можно решить",
        "Если перед ними встанет цель найти работу, это не будет проблемой",
        "Главное не стоять на месте и продолжать учиться, тогда все получиться!"
      ]
    },
    footer: {
      rights: "Все права защищены"
    }
  },
  th: {
    name: "เซอร์เกย์ บูบนอฟ",
    role: "Full stack นักพัฒนา | ที่ปรึกษา",
    development: {
      title: "ประสบการณ์การพัฒนา",
      items: [
        {
          title: "การพัฒนาเว็บ",
          desc: "พัฒนาและดูแลเว็บแอปพลิเคชันโดยใช้ JavaScript, ReactJS และ NodeJS"
        },
        {
          title: "การพัฒนาแอปพลิเคชันมือถือ",
          desc: "ออกแบบและพัฒนาแอปพลิเคชันมือถือด้วย React Native"
        },
        {
          title: "การพัฒนาแบ็กเอนด์",
          desc: "การติดตั้งและกำหนดค่าโซลูชันเซิร์ฟเวอร์โดยใช้ NodeJS และ ExpressJS"
        },
        {
          title: "ฐานข้อมูล",
          desc: "ทำงานกับ ORM และฐานข้อมูล โดยเฉพาะ PostgreSQL ผ่าน TypeORM"
        },
        {
          title: "สถาปัตยกรรม",
          desc: "ใช้วิธีการพัฒนา DDD เพื่อปรับปรุงโครงสร้างโครงการ"
        },
        {
          title: "DevOps",
          desc: "ติดตั้งและดูแลโครงสร้างพื้นฐาน CI/CD โดยใช้ Docker และ GitLab"
        },
        {
          title: "การตรวจสอบ",
          desc: "ตรวจสอบและวิเคราะห์ประสิทธิภาพแอปพลิเคชันโดยใช้ Kibana และ Grafana"
        },
        {
          title: "UI/UX",
          desc: "พัฒนาอินเตอร์เฟซโดยใช้ HTML, CSS และ Figma"
        }
      ]
    },
    techStack: {
      title: "เทคโนโลยีที่ใช้"
    },
    contacts: {
      title: "ติดต่อ",
      email: "อีเมล",
      social: "เครือข่ายสังคม"
    },
    about: {
      title: 'เกี่ยวกับฉัน',
      text: `<p>สำหรับผม การเขียนโปรแกรมไม่ใช่แค่วิธีหาเงิน แต่เป็นวิถีชีวิต</p>
             <p>ในทุกโปรเจค ผมมุ่งมั่นที่จะเพิ่มพูนความรู้และขยายมุมมอง ติดตามเทรนด์อุตสาหกรรมอย่างต่อเนื่อง ผมอ่านหนังสือเชิงวิชาชีพอย่างจริงจังและพัฒนาตัวเองอยู่เสมอ</p>
             <p>ผมเชื่อในพลังของการทำงานเป็นทีม และพยายามที่จะเป็นทั้งผู้ปฏิบัติงานและพี่เลี้ยงสำหรับเพื่อนร่วมงานรุ่นน้อง สนับสนุนการแลกเปลี่ยนความรู้และประสบการณ์ในทีม</p>
             <p>ผมมีโปรเจคส่วนตัวที่ประสบความสำเร็จมาหลายปีแล้ว นอกจากนี้ผมยังสอนการเขียนโปรแกรมให้กับนักเรียนของผม พยายามปลูกฝังความรักและความสนใจในวิชาชีพนี้</p>`
    },
    mentoring: {
      title: "การให้คำปรึกษา",
      intro: [
        "ครั้งหนึ่ง เพื่อนของผมขอให้ช่วยสอน นั่นคือจุดเริ่มต้นของการมีนักเรียนคนแรก",
        "พร้อมกับนักเรียนคนแรก มาพร้อมกับการตระหนักว่ากระบวนการเรียนรู้นำมาซึ่งความสุขอย่างยิ่ง!",
        "เป็นความรู้สึกที่ดีมากที่ได้เห็นคนได้รับโอกาสใหม่ๆ จากการได้รับทักษะใหม่"
      ],
      roadmap: {
        title: "สิ่งที่เราทำ:",
        items: [
          "แนะนำระบบปฏิบัติการ Linux",
          "พัฒนาเว็บไซต์ของคุณเอง",
          "เรียนรู้ภาษาโปรแกรมมิ่ง JavaScript",
          "ทำงานกับ AI (ปัญญาประดิษฐ์)",
          "จัดการและตั้งค่าพื้นที่ทำงาน",
          "เข้าใจโปรแกรมและระบบปฏิบัติการ",
          "เผยแพร่โปรเจคของคุณออนไลน์"
        ]
      },
      technologies: {
        title: "เทคโนโลยีที่เราใช้:",
        items: [
          "Git (ระบบควบคุมเวอร์ชัน)",
          "JavaScript (ภาษาโปรแกรมมิ่ง)",
          "PostgresSQL (ฐานข้อมูล)",
          "CSS (ใช้สำหรับจัดสไตล์เว็บเพจ)",
          "HTML (พื้นฐานของเว็บเพจ)",
          "Docker (เครื่องมือ containerization)",
          "Nginx (เว็บเซิร์ฟเวอร์ยอดนิยม)"
        ]
      },
      conclusion: [
        "เมื่อจบการฝึกอบรม นักเรียนจะมีความเข้าใจเกี่ยวกับการพัฒนาเว็บ",
        "ความกลัวจะหายไปและจะเข้าใจว่าทุกปัญหาสามารถแก้ไขได้",
        "หากพวกเขามีเป้าหมายที่จะหางาน มันจะไม่ใช่ปัญหา",
        "สิ่งสำคัญคือไม่หยุดนิ่งและเรียนรู้ต่อไป แล้วทุกอย่างจะสำเร็จ!"
      ]
    },
    footer: {
      rights: "สงวนลิขสิทธิ์"
    }
  }
} as const; 